/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Bloqueia swipe horizontal no carrinho
(function() {
  var startX = 0;
  var startY = 0;
  var isDrawerOpen = false;

  document.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    var drawer = document.getElementById('sidebar-cart');
    isDrawerOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function(e) {
    if (!isDrawerOpen) return;
    var dx = Math.abs(e.touches[0].clientX - startX);
    var dy = Math.abs(e.touches[0].clientY - startY);
    if (dx > dy && dx > 5) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, { passive: false, capture: true });
})();